export default "__VITE_ASSET__CS1HjEO4__"